// Single source of truth for the inquiry form's service options and for linking
// into it from anywhere on the site with the right service preselected.

export const SERVICES = [
  { value: "website", label: "New website" },
  { value: "website_improve", label: "Improve my site" },
  { value: "gbp_setup", label: "Google Business Profile setup" },
  { value: "local_visibility", label: "Local Visibility" },
  { value: "automations", label: "Quote & call automations" },
  { value: "multiple", label: "Multiple services" },
];

export const isService = (v) => SERVICES.some((s) => s.value === v);

const onHome = () =>
  typeof window !== "undefined" && window.location.pathname === "/";

/** Href that lands on the inquiry form with `service` preselected. */
export function inquiryHref(service) {
  return onHome() ? "#contact" : `/?service=${service}#contact`;
}

/** Preselects the service when the form is already on the current page. */
export function selectInterest(service) {
  window.dispatchEvent(
    new CustomEvent("webjesters:interest", { detail: service })
  );
}
